import { Component } from '@angular/core';

@Component({
    selector: 'iris-card-footer',
    templateUrl: './iris-card-footer.component.html',
    styleUrls: ['./iris-card-footer.component.scss'],
    standalone: false
})
export class IrisCardFooterComponent {}
